import React from 'react';
import { ToggleGroup } from '@/components/ui/toggle-group';
import { PartySizeOption } from './PartySizeSelector';
import { cn } from '@/lib/utils';
import { ToggleGroupSizeItem } from './ToggleGroupSizeItem';

type GroupSizeButtonsProps = {
	options: PartySizeOption[];
	selected: number | undefined;
	onChange: (option: PartySizeOption) => void;
};

const toggleGroupStyles = cn(
	'flex gap-1 md:gap-1.5 lg:gap-2'
);

export function GroupSizeButtons({ options, selected, onChange }: GroupSizeButtonsProps) {
	return (
		<div className="flex overflow-x-auto scrollbar-hide py-1 px-1 lg:py-1.5">
			<ToggleGroup
				type="single"
				value={selected?.toString()}
				onValueChange={(value) => {
					if (value) {
						const selectedOption = options.find(
							(option) => option.value === value
						);
						if (selectedOption) {
							onChange(selectedOption);
						}
					}
				}}
				className={toggleGroupStyles}
			>
				{options.map((option) => (
					<ToggleGroupSizeItem
						key={option.value}
						value={option.value}
						displayValue={option.value}
						disabled={option.disabled}
					/>
				))}
			</ToggleGroup>
		</div>
	);
}